import * as React from 'react';
import * as ReactDOM from 'react-dom';

import App from '@/App';

const rootEl = document.getElementById('root');
ReactDOM.render(<App />, rootEl);

// comment in for PWA with service worker in production mode
// registerServiceWorker();
